exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.lxm-cf-project-stat__stat[data-v-4379a6c2] {\n  margin-top: 1.43rem;\n}\n", "", {"version":3,"sources":["/./src/components/Main/Cf/Project/src/components/Main/Cf/Project/Stat.vue","/./src/components/Main/Cf/Project/Stat.vue"],"names":[],"mappings":";AAUA;EACE,oBAAA;CCTD","file":"Stat.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n@import '../../../styles/index.styl'\n.lxm-cf-project-stat__stat\n  margin-top: spacing-big\n",".lxm-cf-project-stat__stat {\n  margin-top: 1.43rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-4379a6c2&scoped=true!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main/Cf/Project/Stat.vue
// module id = 625
// module chunks = 0